export { mergeOptions } from './mergeOptions';
export {
  CompositionContext,
  useCompositionRegistry,
  useCompositionOption,
} from './CompositionOptionsContext';
export type { CompositionRegistry, CompositionContextValue } from './types';
